export enum EDataSwitchEvents {
    INIT = 'dataSwitch:initialize',
}
